import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Marquee from "@/components/Marquee";
import Countdown from "@/components/Countdown";
import QuickPick from "@/components/QuickPick";
import HypeBanner from "@/components/HypeBanner";
import ActivityToast from "@/components/ActivityToast";
import Hero from "@/sections/Hero";
import Story from "@/sections/Story";
import ShowPromo from "@/sections/ShowPromo";
import Experience from "@/sections/Experience";
import AboutSusan from "@/sections/AboutSusan";
import Tickets from "@/sections/Tickets";
import Remembrance from "@/sections/Remembrance";
import Gifting from "@/sections/Gifting";
import BookHost from "@/sections/BookHost";
import Testimonials from "@/sections/Testimonials";
import Venue from "@/sections/Venue";
import Faq from "@/sections/Faq";
import { Reveal } from "@/components/Reveal";
import { PRESS, EVENT } from "@/lib/data";
import LiveSeats from "@/components/LiveSeats";
import LowStockAlert from "@/components/LowStockAlert";
import { scrollToSection } from "@/lib/scroll";

const Home = () => (
  <div className="relative">
    <Nav />
    <main>
      <LowStockAlert />
      <Hero />
      <HypeBanner />
      <Marquee items={PRESS} label="As Seen On" />
      <Story />
      <ShowPromo />
      <Experience />
      <AboutSusan />
      <Tickets />
      <Remembrance />
      <Gifting />
      <BookHost />
      <Testimonials />
      <Venue />
      <Faq />

      {/* Final CTA */}
    <section
      className="relative py-16 sm:py-24 overflow-hidden text-center"
      style={{ background: "radial-gradient(ellipse 70% 60% at 50% 110%, #1d1b4b 0%, #0B1021 70%)" }}
    >
        <div className="max-w-3xl mx-auto px-5 sm:px-8 relative z-10">
          <Reveal>
            <p className="eyebrow">One Night Only · {EVENT.dateLabel}</p>
            <h2 className="font-display text-4xl sm:text-6xl mt-6 text-[#FDFBF7] leading-tight">
              Take your seat <em className="text-gold-gradient italic">in the light</em>
            </h2>
            <p className="text-[#9CA3AF] font-light mt-6 max-w-xl mx-auto">
              All {EVENT.capacity.toLocaleString()} seats of the historic Saban are on the map —
              or let Fast Pick hold the best ones for you. Tickets from $90, and every zone is
              live right now.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 flex flex-col items-center gap-8">
              <Countdown />
              <LiveSeats />
              <button
                onClick={() => scrollToSection("seating")}
                data-testid="final-cta-button"
                className="btn-gold rounded-full px-12 py-5 text-base font-bold tracking-wide"
              >
                Reserve Your Seats
              </button>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
    <Footer />
    <QuickPick />
    <ActivityToast />
  </div>
);

export default Home;
